const isInternalUser = (useData: any) => {
  if (useData?.data?.email?.includes("amberstudent.com")) {
    return true;
  }
  return false;
};

export default isInternalUser;
